import FuncionalismoService from '@/services/FuncionalismoService';

export const funcionalismo = {
    namespaced: true,
    actions: {

        buscarConsolidadoPorTipoRegime( { dispatch }, {dataInicio, dataFim} ) {
            return FuncionalismoService.buscarConsolidadoPorTipoRegime({dataInicio, dataFim})
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        buscarConsolidadoPorEscolaridade( { dispatch }, {dataInicio, dataFim, agrupamento} ) {
            return FuncionalismoService.buscarConsolidadoPorEscolaridade({dataInicio, dataFim, agrupamento})
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        buscarConsolidadoPorTipoRacaSexo( { dispatch }, {dataInicio, dataFim, agrupamento} ) {
            return FuncionalismoService.buscarConsolidadoPorTipoRacaSexo({dataInicio, dataFim, agrupamento})
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        buscarConsolidadoPorOrgao( { dispatch }, {dataInicio, dataFim} ) {
            return FuncionalismoService.buscarConsolidadoPorOrgao({dataInicio, dataFim})
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        buscarConsolidadoPorCargo( { dispatch }, {dataInicio, dataFim} ) {
            return FuncionalismoService.buscarConsolidadoPorCargo({dataInicio, dataFim})
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        buscarServidoresPorFaixaEtaria( { dispatch }, { agrupamento, dataInicio, dataFim } ) {
            return FuncionalismoService.buscarServidoresPorFaixaEtaria({ agrupamento, dataInicio, dataFim })
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        buscarHistoricoAdmissoesVacanciasDosServidores( { dispatch }) {
            return FuncionalismoService.buscarHistoricoAdmissoesVacanciasDosServidores()
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        buscarHistoricoAdmissoesVacanciasDosServidoresPorRaca( { dispatch }, { dataInicio, dataFim } ) {
            return FuncionalismoService.buscarHistoricoAdmissoesVacanciasDosServidoresPorRaca({ dataInicio, dataFim })
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        buscarHistoricoAdmissoesDosServidoresNoIntervalo( { dispatch }, { dataInicio, dataFim } ) {
            return FuncionalismoService.buscarHistoricoAdmissoesDosServidoresNoIntervalo({ dataInicio, dataFim })
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        buscarHistoricoVacanciasDosServidoresNoIntervalo( { dispatch }, { agrupamento, dataInicio, dataFim } ) {
            return FuncionalismoService.buscarHistoricoVacanciasDosServidoresNoIntervalo({ agrupamento, dataInicio, dataFim })
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        buscarHistoricoAposentadoriasDosServidoresNoIntervalo( { dispatch }, { dataInicio, dataFim } ) {
            return FuncionalismoService.buscarHistoricoAposentadoriasDosServidoresNoIntervalo({ dataInicio, dataFim })
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        buscarHistoricoServidoresPorCaracteristicasNoIntervalo( { dispatch }, { dataReferencia, agrupamento, dataInicio, dataFim } ) {
            return FuncionalismoService.buscarHistoricoServidoresPorCaracteristicasNoIntervalo({ dataReferencia, agrupamento, dataInicio, dataFim })
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        buscarFolhaPagamentoProfessoresConsolidadoPorTipoRegime( { dispatch }, { dataInicio, dataFim } ) {
            return FuncionalismoService.buscarFolhaPagamentoProfessoresConsolidadoPorTipoRegime({ dataInicio, dataFim })
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        buscarFolhaPagamentoProfessoresConsolidadoPorCargo( { dispatch }, { dataInicio, dataFim, regime } ) {
            return FuncionalismoService.buscarFolhaPagamentoProfessoresConsolidadoPorCargo({ dataInicio, dataFim, regime })
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        buscarFolhaPagamentoProfessoresPorRegimeDeContratacao( { dispatch }, { dataInicio, dataFim } ) {
            return FuncionalismoService.buscarFolhaPagamentoProfessoresPorRegimeDeContratacao({ dataInicio, dataFim })
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        buscarFolhaPagamentoProfessoresConsolidadoPorRacaSexo( { dispatch }, { dataInicio, dataFim, regime } ) {
            return FuncionalismoService.buscarFolhaPagamentoProfessoresConsolidadoPorRacaSexo({ dataInicio, dataFim, regime })
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        buscarFolhaPagamentoProfessoresPorFaixaEtariaServidores( { dispatch }, { dataInicio, dataFim, regime } ) {
            return FuncionalismoService.buscarFolhaPagamentoProfessoresPorFaixaEtariaServidores({ dataInicio, dataFim, regime })
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        
        distribuicaoPorRegimeContratacao( { dispatch }, {dataInicio, dataFim, agrupamento} ) {
            return FuncionalismoService.distribuicaoPorRegimeContratacao({dataInicio, dataFim, agrupamento})
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },

    },
    state: {},
    mutations: {},
};